interface CurrencyAmountInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  currencySymbol: string;
  disabled?: boolean;
  placeholder?: string;
  type?: 'number' | 'text';
  inputMode?: 'decimal' | 'numeric' | 'text';
  'aria-label'?: string;
  'aria-invalid'?: boolean;
  className?: string;
}

/** Standard amount field with currency symbol as a leading addon (not overlaid). */
export function CurrencyAmountInput({
  id,
  value,
  onChange,
  currencySymbol,
  disabled = false,
  placeholder = '0.00',
  type = 'number',
  inputMode,
  'aria-label': ariaLabel,
  'aria-invalid': ariaInvalid,
  className = '',
}: CurrencyAmountInputProps) {
  return (
    <div
      className={`flex h-8 w-full rounded-md border border-gray-200 bg-white overflow-hidden focus-within:border-green-500 ${
        disabled ? 'opacity-60 bg-gray-50' : ''
      } ${className}`}
    >
      <span className="inline-flex items-center px-2.5 bg-gray-50 border-r border-gray-200 text-xs font-medium text-gray-500 flex-shrink-0 select-none">
        {currencySymbol}
      </span>
      <input
        id={id}
        type={type}
        inputMode={inputMode ?? (type === 'number' ? 'decimal' : undefined)}
        min={type === 'number' ? 0.01 : undefined}
        step={type === 'number' ? 0.01 : undefined}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        aria-invalid={ariaInvalid}
        className="flex-1 min-w-0 h-full px-2.5 text-xs font-normal text-gray-800 outline-none border-0 bg-transparent placeholder:font-normal placeholder:text-xs placeholder:text-gray-400 disabled:cursor-not-allowed"
      />
    </div>
  );
}
